import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { mapState } from 'pinia';
import { getSmoother } from 'utils/ScrollSmootherInstance.js';
import matchMediaConfig from 'utils/matchMedia.js'
import _ from "lodash";

gsap.registerPlugin(ScrollTrigger);
gsap.registerEase("easeInOutCubic", [0.42, 0, 0.21, 0.99]);

export default {
	data() {
		return {
			rowElementActive: null,
			rowElementDefault: null,
			textWrapElementsHeight: [],
			periodsTimeline: null,
			autoAnimations: null,
			scrollDisabled: false,
		};
	},
	methods: {
		disableScroll() {
			this.scrollDisabled = true;
			document.body.style.overflow = 'hidden';
		},
		enableScroll() {
			this.scrollDisabled = false;
			document.body.style.overflow = '';
		},
		makePeriodActive: _.debounce(function (i) {
			this.periods.forEach((element, index) => {
				element.isActive = false;
			});

			setTimeout(() => {
				this.periods[i].isActive = true;
			}, 150);
			// element.isActive = (i == index);
		}, 100),
		animateDesktop(periods) {
			let tl = null
			let periodsTimeline = null
			let periodsTimeline2 = null

			tl?.kill()
			periodsTimeline?.kill()
			periodsTimeline2?.kill()

			const imgContainer = document.querySelector('.development__col--img');

			const blockHeight = document.querySelector('.animation-section2').offsetHeight;
			const textWrapElements = document.querySelectorAll('.development__row-text-wrap');
			const headerHeight = document.querySelector('header').offsetHeight;
			const previousBlockHeight = document.querySelector('.block-simple').offsetHeight;
			const deviderItem = document.querySelector('.development__row-devider').offsetHeight;
			const progressBars = document.querySelectorAll('.development__timeline-progress');

			progressBars.forEach(bar => {
				gsap.set(bar, { height: '0%' });
			});

			periods.forEach((period, index) => {
				const newImg = document.createElement('img');
				newImg.className = 'development__img development__img--new';
				newImg.src = period.image_url;

				imgContainer.appendChild(newImg);

				if (index === 0) {
					gsap.set(newImg, {
						yPercent: 0,
						opacity: 1
					});
				} else {
					gsap.set(newImg, {
						yPercent: 100,
						opacity: 1
					});
				}
			});
			const smoother = getSmoother();
			const newImgs = document.querySelectorAll('.development__img');

			periodsTimeline = gsap.timeline({
				paused: true,
				onReverseComplete: () => {
					smoother.paused(false);
				}
			});
			periodsTimeline
				.to(newImgs[1], {
					yPercent: 0,
					opacity: 1,
					duration: 1,
					ease: "easeInOutCubic",
				}, "<")

				.to(".development__row:nth-child(1) .development__row-text", {
					height: "0px",
					duration: 1,
					opacity: 0,
					// display: "none",
					ease: "easeInOutCubic",
					onReverseComplete: () => periods.forEach((p, i) => p.isActive = (i === 0))
				}, "<")
				.to(".development__row:nth-child(1) .development__row-devider", {
					height: "0px",
					duration: 1,
					ease: "easeInOutCubic",
				}, "<")
				.to(".development__row:nth-child(2) .development__row-text", {
					height: textWrapElements[1].offsetHeight,
					// display: "flex",
					opacity: 1,
					duration: 1,
					ease: "easeInOutCubic"
				},
					"<"
				)
				.to(".development__row:nth-child(2) .development__row-devider", {
					height: deviderItem,
					duration: 1,
					ease: "easeInOutCubic",
				}, "<")
				.call(() => {
					smoother.paused(false)
				});

			periodsTimeline2 = gsap.timeline({
				paused: true,
				onReverseComplete: () => {
					smoother.paused(false);
				}
			});
			periodsTimeline2
				.to(newImgs[2], {
					yPercent: 0,
					opacity: 1,
					duration: 1,
					ease: "easeInOutCubic",
				}, "<")

				.to(".development__row:nth-child(2) .development__row-text", {
					height: "0px",
					display: "none",
					opacity: 0,
					duration: 1,
					ease: "easeInOutCubic",
					onReverseComplete: () => periods.forEach((p, i) => p.isActive = (i === 1))

				}, "<")
				.to(".development__row:nth-child(2) .development__row-devider", {
					height: "0px",
					duration: 1,
					ease: "easeInOutCubic",
				}, "<")
				.to(".development__row:nth-child(3) .development__row-text", {
					height: textWrapElements[2].offsetHeight,
					display: "flex",
					opacity: 1,
					duration: 1,
					ease: "easeInOutCubic"
				},
					"<"
				)
				.to(".development__row:nth-child(3) .development__row-devider", {
					height: deviderItem,
					duration: 1,
					ease: "easeInOutCubic",
				}, "<")
				.call(() => {
					smoother.paused(false)
				});

			tl = gsap.timeline({
				scrollTrigger: {
					invalidateOnResize: true,
					toggleActions: "restart none none reverse",
					trigger: ".animation-section2",
					pin: true,
					start: `top ${headerHeight}px`,
					end: `=+${blockHeight * 2}`,
					scrub: true
				}
			});

			tl.set(".development__row:nth-child(1) .development__row-text", {
				height: textWrapElements[0].offsetHeight
			});
			tl.set(".development__row:nth-child(2) .development__row-text", {
				height: '0px',
				// display: "none",
				opacity: 0
			});
			tl.set(".development__row:nth-child(3) .development__row-text", {
				// display: "none",
				height: '0px',
				opacity: 0
			});

			tl.set(".development__row:nth-child(2) .development__row-devider", {
				height: '0px',
			});
			tl.set(".development__row:nth-child(3) .development__row-devider", {
				height: '0px',
			});

			tl.to(progressBars[0], {
				height: '100%',
				ease: "linear",
				onComplete: () => {
					periods.forEach((p, i) => p.isActive = i === 1);
					smoother.paused(true)
					periodsTimeline.play()
				},
			});
			tl.to(progressBars[1], {
				height: '100%',
				ease: "linear",
				onComplete: () => {
					periods.forEach((p, i) => p.isActive = i === 2);
					smoother.paused(true)
					periodsTimeline2.play()
				},
				onReverseComplete: () => {
					periods.forEach((p, i) => p.isActive = i === 0);
					smoother.paused(true)
					periodsTimeline.reverse(0)
				}
			});
			tl.to(progressBars[2], {
				height: '100%',
				ease: "linear",
				onReverseComplete: () => {
					periods.forEach((p, i) => p.isActive = i === 1);
					smoother.paused(true)
					periodsTimeline2.reverse(0)
				}
			});

			//TODO ANIMATION
			if (this.getScrollEnabled && true) {
				// настройки для автоматического скролла блока вверх
				ScrollTrigger.create({
					id: "block4.1",
					trigger: ".animation-section2",
					start: `top ${headerHeight + previousBlockHeight}px`,
					// start: this.scrollDownPosition,
					markers: false,
					// end: `top ${ headerHeight }px`,
					onEnter: () => {
						if (this.getScrollDirection === 'down') {

							gsap.to(smoother, {
								scrollTop: Math.min(
									ScrollTrigger.maxScroll(window),
									smoother.offset(".animation-section2", `top ${headerHeight}px`)
								),
								duration: 1.2,
								ease: "smoother",
								onStart: () => {
									smoother.smooth(0.1);
									smoother.paused(true)
								},
								onComplete: () => {
									smoother.paused(false)
									smoother.smooth(3);
								}
							});
						}
					},
				});
			}
		},
		animateMobile(periods) {
			let tl = null
			let periodsTimeline = null
			let periodsTimeline2 = null

			tl?.kill()
			periodsTimeline?.kill()
			periodsTimeline2?.kill()

			const imgContainer = document.querySelector('.development__col--img');
			const blockHeight = document.querySelector('.animation-section2').offsetHeight;
			const blocksRow = document.querySelectorAll('.development__row');
			const headerHeight = document.querySelector('header').offsetHeight;
			const progressBars = document.querySelectorAll('.development__timeline-progress');
			const previousBlockHeight = document.querySelector('.block-simple').offsetHeight;
			imgContainer.querySelectorAll('.development__img--new').forEach(img => img.remove());

			periods.forEach((period, index) => {
				const newImg = document.createElement('img');
				newImg.className = 'development__img development__img--new';
				newImg.src = period.image_url;

				imgContainer.appendChild(newImg);

				if (index === 0) {
					gsap.set(newImg, {
						yPercent: 0,
						opacity: 1
					});
				} else {
					gsap.set(newImg, {
						yPercent: 100,
						opacity: 1
					});
				}
			});


			const smoother = getSmoother();
			const newImgs = document.querySelectorAll('.development__img');
			let isPeriodsTimeline = false;
			let isPeriodsTimeline2 = false;

			periodsTimeline = gsap.timeline({
				paused: true,
				onReverseComplete: () => {
					this.makePeriodActive(0);
					smoother.paused(false);
					this.enableScroll();
				}
			});


			periodsTimeline
				.to(newImgs[1], {
					yPercent: 0,
					opacity: 1,
					duration: 0.3,
					ease: "easeInOutCubic",
					onStart: () => {
						this.makePeriodActive(1);
					}
				}, '<')
				/*
								.to(blocksRow[0], {
									y: -(blocksRow[0].offsetHeight + 24),
									duration: 0.3,
									opacity: 0,
									ease: "easeInOutCubic",
								}, '<')

								.to(blocksRow[1], {
									y: -(blocksRow[0].offsetHeight + 24),
									opacity: 1,
									duration: 0.3,
									ease: "easeInOutCubic"
								}, '<')

								.to(blocksRow[2], {
									y: -(blocksRow[0].offsetHeight + 24),
									opacity: 1,
									duration: 0.3,
									ease: "easeInOutCubic"
								}, '<')
				*/
				.call(() => {
					smoother.paused(false);
					this.enableScroll();
				});


			periodsTimeline2 = gsap.timeline({
				paused: true,
				onReverseComplete: () => {
					this.makePeriodActive(1);
					smoother.paused(false);
					this.enableScroll();
				}
			});


			periodsTimeline2
				.to(newImgs[2], {
					yPercent: 0,
					opacity: 1,
					duration: 0.3,
					ease: "easeInOutCubic",
					onStart: () => {
						this.makePeriodActive(2);
					}
				}, '<')
				/*
								.to(blocksRow[1], {
									y: -(blocksRow[0].offsetHeight + blocksRow[1].offsetHeight + 24 * 2),
									duration: 0.3,
									opacity: 0,
									ease: "easeInOutCubic",
								}, '<')

								.to(blocksRow[2], {
									y: -(blocksRow[0].offsetHeight + blocksRow[1].offsetHeight + 24 * 2),
									opacity: 1,
									duration: 0.3,
									ease: "easeInOutCubic"
								}, '<')
				*/
				.call(() => {
					smoother.paused(false);
					this.enableScroll();
				});

			tl = gsap.timeline({
				scrollTrigger: {
					trigger: ".animation-section2",
					pin: true,
					start: `top ${headerHeight}px`,
					end: `=+${blockHeight * 2}`,
					scrub: true,
				}
			});

			tl.set(".development__row:nth-child(1) .development__row-text", {
				display: "flex",
				opacity: 1
			});
			// tl.set(".development__row:nth-child(2) .development__row-text", {
			// 	display: "flex",
			// 	opacity: 1
			// });
			// tl.set(".development__row:nth-child(3) .development__row-text", {
			// 	display: "flex",
			// 	opacity: 1
			// });


			tl.to(progressBars[0], {
				onComplete: () => {
					smoother.paused(true);
					this.disableScroll();
					periodsTimeline.play();
				},
			});
			tl.to(progressBars[0], {
				onComplete: () => {
					smoother.paused(true);
					this.disableScroll();
					periodsTimeline2.play();
				},
				onReverseComplete: () => {
					smoother.paused(true);
					this.disableScroll();
					periodsTimeline.reverse(0);
				}
			});
			tl.to(progressBars[0], {
				onReverseComplete: () => {
					smoother.paused(true);
					this.disableScroll();
					periodsTimeline2.reverse(0);
				}
			});
		},
		initAnimations(periods) {
			const mm = gsap.matchMedia()
			mm.add(matchMediaConfig, (context) => {
				const { isDesktop, isMobile } = context.conditions

				context.add(() => {
					if (window?.innerWidth > 1279) {
						// if (isDesktop) {
						this.animateDesktop(periods);
					}

					/*
					if (isMobile) {
						this.animateMobile(periods);
					}
					*/
				})
			})
		},
		killAnimations() {
			ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		},
	},
	computed: {
		...mapState(useViewportStore, ["getIsMobileState"]),
		...mapState(usePageAnimationStore, ["getPageCanAnimateBlocks", "getScrollDirection"]),
		...mapState(useScrollStore, ["getScrollEnabled", "scrollUpPosition", "scrollDownPosition"]),
	},
	mounted() {
		// this.$nextTick(() => {
		// 	if (this.getPageCanAnimateBlocks) {
		// 		this.initAnimations(this.periods);
		// 		window.addEventListener('resize', () => {
		// 			ScrollTrigger.refresh();
		// 		});
		// 	}
		// });
	},
	beforeUnmount() {
		this.killAnimations();
	},
	watch: {
		getPageCanAnimateBlocks(state) {
			if (state) {
				this.$nextTick(() => {
					this.initAnimations(this.periods);
				})
			}
		},
	}
}
